var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right"},[_c('a-icon',{attrs:{"type":"printer","title":"打印"},on:{"click":function($event){return _vm.$print(_vm.id)}}}),_c('a-icon',{attrs:{"type":"download","title":"下载"},on:{"click":function($event){return _vm.$download(_vm.id)}}})],1),_c('div',{attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }